import React from 'react';
import { Typography } from '@mui/material';
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';
import ThumbUpAltOutlinedIcon from '@mui/icons-material/ThumbUpAltOutlined';
import { RoadmapItem } from '@/models/RoadmapItem';
import './LikeButton.css';

interface LikeButtonProps {
    data: RoadmapItem;
    onLike: (jiraId: string, isLiked: boolean) => void;
    variant?: 'grid' | 'flyout';
}

const LikeButton: React.FC<LikeButtonProps> = ({ data, onLike, variant = 'grid' }) => {
    const handleClick = (ev: React.MouseEvent) => {
        ev.stopPropagation();
        onLike(data.jiraId, !data.isLiked);
    };

    const iconClass = variant === 'grid' ? 'like-button-icon-grid' : 'like-button-icon-flyout';
    const countClass = variant === 'grid' ? 'like-button-count-grid' : 'like-button-count-flyout';

    return (
        <span className="like-button-container">
            {data.isLiked ? (
                <ThumbUpAltIcon
                    className={`like-button-icon ${iconClass}`}
                    titleAccess="Click to undo like"
                    onClick={handleClick}
                />
            ) : (
                <ThumbUpAltOutlinedIcon
                    className={`like-button-icon ${iconClass}`}
                    titleAccess="Click to like"
                    onClick={handleClick}
                />
            )}
            <Typography className={`like-button-count ${countClass}`}>
                {data.likeCount}
            </Typography>
        </span>
    );
};

export default LikeButton;
